import type { Tile } from '../hex/types';
import { t, type Language } from '../../i18n/translations';

function resourceLabel(lang: Language, key: string): string {
    const label = t(lang, `resource.${key}`);
    return label === `resource.${key}` ? key : label;
}

export function resourceSummary(tile: Tile, lang: Language): string {
    return resourceSummaryLines(tile, lang).join(', ');
}

export function resourceSummaryLines(tile: Tile, lang: Language): string[] {
    const parts: string[] = [];
    for (const [key, value] of Object.entries(tile.resources)) {
        const label = resourceLabel(lang, key);
        if (Array.isArray(value)) {
            const total = value.reduce((sum, entry) => sum + entry.amount, 0);
            parts.push(`${label}: ${total}`);
        } else if (value && typeof value.amount === 'number') {
            parts.push(`${label}: ${value.amount}`);
        }
    }
    if (tile.deposits) {
        const deposits: Array<[string, number | undefined]> = [
            ['deposit.stone', tile.deposits.stoneDeposit],
            ['deposit.iron', tile.deposits.ironDeposit],
            ['deposit.gold', tile.deposits.goldDeposit],
        ];
        deposits.forEach(([key, value]) => {
            if (typeof value === 'number') parts.push(`${t(lang, key)}: ${value}`);
        });
    }
    if (tile.ecology) {
        const attrs: Array<[string, number | undefined]> = [
            ['attr.canopyCap', tile.ecology.canopyCap],
            ['attr.fertility', tile.ecology.fertility],
            ['attr.wildlifeCap', tile.ecology.wildlifeCap],
            ['attr.fishCap', tile.ecology.fishCap],
            ['attr.corruption', tile.ecology.corruption],
        ];
        attrs.forEach(([key, value]) => {
            if (typeof value === 'number') parts.push(`${t(lang, key)}: ${value}`);
        });
    }
    return parts;
}
